import { Controller } from 'react-hook-form'
import * as z from 'zod'

import { YesNoRadioGroup } from '~/shadcn/ui/yes-no-radio-group'
import { FormStep } from '~/@pages_onboarding/investor-analysis/_analysis-form/FormStep'
import { StepTitle } from '~/@pages_onboarding/investor-analysis/_analysis-form/StepTitle'
import { useFormStepSophisticated } from '../form-step-sophisticated/useFormStepSophisticated'
import { useQuestionsV1 } from '../../questions'

const step2Schema = z.object({
  experiencedInFinanceOrExecutiveRole: z.boolean(),
})

export type Step2Data = z.infer<typeof step2Schema>

export function Step2() {
  const { onStepCompleted, formData } = useFormStepSophisticated()
  const question =
    useQuestionsV1().sophisticated.experiencedInFinanceOrExecutiveRole

  return (
    <FormStep
      defaultValues={formData}
      schema={step2Schema}
      onStepCompleted={onStepCompleted}
      render={({ control }) => (
        <>
          <StepTitle>{question.question.label}</StepTitle>
          <Controller
            control={control}
            name="experiencedInFinanceOrExecutiveRole"
            render={({ field }) => (
              <YesNoRadioGroup
                value={field.value}
                labelYes={question.answers.true.label}
                labelNo={question.answers.false.label}
                onValueChange={field.onChange}
              />
            )}
          />
        </>
      )}
    />
  )
}
